import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import { FullViewProps } from '../types';
import AutoSizedText from '../_partials/AutoSizedText';
import ClockIcon from '@wix/da-ds/pkg/Icons/24x24/Clock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { getReadingTimeMinutes } from '../../Thumb/helpers';
import Timestamp from '../../../Timestamp';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';

import s from './Journal.scss';

const JournalFullView: React.FC<FullViewProps> = ({
  deviation,
  width,
  height,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { isFullscreen, isTheater } = useDeviationViewContext();
  const style =
    isTheater || isFullscreen || isMobile ? { width, height } : { width };
  const minutes = getReadingTimeMinutes(deviation.textContent);

  return (
    <div
      className={classnames(s['root'], isFullscreen && s['fullscreen'])}
      style={style}
    >
      <div className={s['content-wrap']}>
        <div className={s['title-wrap']}>
          <AutoSizedText
            className={s['title']}
            tooBigClassName={s['better-fit']}
            maxHeight={180}
          >
            {getDeviationTitle(deviation)}
          </AutoSizedText>
          <div className={s['subtitle']}>
            <span className={s['published']}>
              <Timestamp timestamp={deviation.publishedTime} />
            </span>
            {!!minutes && (
              <span className={s['read-time']}>
                <ClockIcon
                  className={s['clock']}
                  size={IconSize.SMALL}
                  disableDefaultColors
                />
                <span>
                  {t('deviationview.journal.stage.read', { count: minutes })}
                </span>
              </span>
            )}
          </div>
        </div>
        {isFullscreen && (
          <TextualContent deviation={deviation} withArtist={false} />
        )}
      </div>
    </div>
  );
};
JournalFullView.displayName = 'JournalFullView';

export default JournalFullView;
